<template lang='pug'>
span
  VJsoneditor(
    ref='jsonEditor'
    height='600px',
    :options='options',
    :plus='false'
    @hook:mounted='onCreateEditor')
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
export default {
  model: {
    prop: 'body',
    event: 'update'
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    bodyParameters: {
      type: Object,
      default: () => ({})
    },
    previewMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VJsoneditor
  },
  data () {
    return {
      jsonData: {},
      jsonTest: ''
    }
  },
  computed: {
    options () {
      return {
        mode: 'code',
        modes: ['code', 'tree'],
        onChangeText: this.onChangeText,
        onEditable: () => !this.readOnly && !this.previewMode
      }
    }
  },
  watch: {
    bodyParameters: {
      deep: true,
      handler () {
        if (this.previewMode) {
          this.updateJson()
        }
      }
    }
  },
  methods: {
    onChangeText () {
      this.$emit('update', this.$refs.jsonEditor.editor.getText())
    },
    replaceProps (string, propsObj) {
      let result = string
      for (const key in propsObj) {
        const regex = `%\\{${key}\\}`
        const re = new RegExp(regex, 'g')
        result = result.replace(re, propsObj[key])
      }
      return result
    },
    updateJson () {
      let json = this.replaceProps(this.body, this.bodyParameters)
      try {
        if (json) {
          json = JSON.stringify(JSON.parse(json), null, 2)
        }
      } catch (e) {
      } finally {
        this.$refs.jsonEditor.editor.setText(json)
      }
    },
    setText () {
      this.$refs.jsonEditor.editor.setText(this.body)
    },
    onCreateEditor () {
      if (this.previewMode) {
        this.updateJson()
      } else {
        this.setText()
      }
    }
  }
}
</script>

<style>
.jsoneditor {
  border: thin solid rgba(67, 160, 72, 0);
}
.jsoneditor-menu {
  background-color: rgb(67, 160, 71);
  border-bottom: 1px solid rgb(67, 160, 71);
}
.jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
